import React, {useState} from 'react';
import {Button, FormControl, FormLabel, Modal, Spinner} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {sendMessage} from "../../API/msisdnApi";
import {toast} from "react-toastify";
import messageFromError from "../../utils/errorUtils";
import useMyTranslation from "../../Hooks/useMyTranslation";

const SendMessageToMsisdnModal = ({msisdn, show, onHide}) => {

    const {t} = useTranslation()
    const tDialog = useMyTranslation('pages.dashboard.sendMessageDialog')
    const [spinnerVisible, setSpinnerVisible] = useState(false)
    const [messagesByMsisdn, setMessagesByMsisdn] = useState({});

    // Retrieve the current message for the msisdn, or initialize if not present
    const currentMessage = messagesByMsisdn[msisdn?.id] || { title: '', message: '' };

    // Update the title for the current msisdn
    const titleChange = (title) => {
        setMessagesByMsisdn({
            ...messagesByMsisdn,
            [msisdn.id]: { ...currentMessage, title },
        });
    };

    // Update the body for the current msisdn
    const bodyChange = (body) => {
        setMessagesByMsisdn({
            ...messagesByMsisdn,
            [msisdn.id]: { ...currentMessage, message: body },
        });
    };

    // Send message and handle response
    const sendMessageToMsisdn = async () => {
        try {
            setSpinnerVisible(true);
            await sendMessage(msisdn.id, currentMessage);
            setMessagesByMsisdn({
                ...messagesByMsisdn,
                [msisdn.id]: { title: '', message: '' }, // Reset message for this msisdn
            });
            toast.success(tDialog('sentSuccessfully'));
            onHide && onHide();
        } catch (error) {
            toast.error(messageFromError(error));
        } finally {
            setSpinnerVisible(false);
        }
    };

    if(!msisdn)
        return null;

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton className='modal-header'>
                <Modal.Title>{t('pages.dashboard.sendMessageDialog.title', { msisdn: msisdn?.fullName ?? msisdn.id})}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormLabel>{t('pages.dashboard.sendMessageDialog.messageTitle')}</FormLabel>
                <FormControl type='text' placeholder={t('pages.dashboard.sendMessageDialog.messageTitlePlaceholder')} value={currentMessage.title} onChange={(e) => {titleChange(e.target.value)}}/>
                <FormLabel className='mt-3'>{t('pages.dashboard.sendMessageDialog.messageContent')}</FormLabel>
                <FormControl as='textarea' rows={6} placeholder={t('pages.dashboard.sendMessageDialog.messageContentPlaceholder')} style={{resize: 'none'}} value={currentMessage.message} onChange={(e) => {bodyChange(e.target.value)}}/>
            </Modal.Body>
            <Modal.Footer>
                {
                    //Show spinner or button
                    spinnerVisible ? <Spinner animation="border" variant="success" /> :
                        <Button variant="success" onClick={sendMessageToMsisdn}>
                            {t('global.operations.send')}
                        </Button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default SendMessageToMsisdnModal;